import { useEffect, useState } from 'react';
import customAxios from '../../util/Api';
import authHeader from '../../../../services/auth/jwt/auth-header';

const useManageMetadata = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);

  // 🟢 Fetch all customer locations
  const fetchLocations = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await customAxios.get('/CRM/GetAllCustomerLocations', {
        headers: authHeader(),
      });

      if (res.status === 200 && Array.isArray(res.data)) {
        setLocations(res.data);
      } else {
        throw new Error('Unexpected API response');
      }
    } catch (err) {
      console.error('Error fetching customer locations:', err);
      setError('Failed to fetch customer locations');
    } finally {
      setLoading(false);
    }
  };

  // 🟢 Add new location
  const addLocation = async data => {
    try {
      setLoading(true);

      const payload = {
        destinationName: data.destinationName || '',
        custCode: data.custCode || '',
        latitude: String(data.latitude || ''),
        longitude: String(data.longitude || ''),
        siteAssessmentId: Number(data.siteAssessmentId || 0),
        customerName: data.customerName || '',
      };

      const res = await customAxios.post('/CRM/AddCustomerLocation', payload, {
        headers: authHeader(),
      });

      if (res.status === 200) {
        console.log('✅ Location added successfully');
        await fetchLocations(); // refresh list after adding
      } else {
        console.warn('⚠️ Unexpected status while adding location:', res.status);
      }
    } catch (err) {
      console.error('❌ Error adding new location:', err);
      setError('Failed to add new location');
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  // 🟢 Edit existing location
  const updateLocation = async data => {
    try {
      setLoading(true);

      const payload = {
        id: data.id,
        destinationName: data.destinationName,
        custCode: data.custCode,
        latitude: String(data.latitude || ''),
        longitude: String(data.longitude || ''),
        siteAssessmentId: Number(data.siteAssessmentId || 0),
        customerName: data.customerName,
      };

      const res = await customAxios.post('/CRM/EditCustomerLocation', payload, {
        headers: authHeader(),
      });

      if (res.status === 200) {
        await fetchLocations();
      }
    } catch (err) {
      console.error('Error updating location:', err);
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  const openEditModal = () => {
    setIsAddMode(false);
    setIsModalOpen(true);
  };

  const openAddModal = () => {
    setIsAddMode(true);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  return {
    locations,
    loading,
    error,
    isModalOpen,
    isAddMode,
    openAddModal,
    openEditModal,
    closeModal,
    addLocation, // 🟢 exported
    updateLocation,
  };
};

export default useManageMetadata;
